










import { Vue, Component } from "@/shared/vuepack";
import { useFocusReload } from "@/employer/composables/useFocusReload";
import ProgramHealthTab from "@/employer/components/dashboard/ProgramHealthTab.vue";
import ProductsTab from "@/employer/components/dashboard/ProductsTab.vue";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";

@Component({
  components: {
    CommonTabs,
    ProgramHealthTab,
    ProductsTab,
  }
})
export default class MyProgram extends Vue {
  created () {
    useFocusReload();
  }
}
